export const metrics = [
  ['eligible_reservations', 'Reservations', 'all'],
  ['planned_reservations', 'Reservations with plans', 'planned'],
  ['adoption_rate', 'Planning adoption', 'planned'],
  ['activities_per_trip', 'Activities per planned trip', 'planned'],
  ['saved_activities', 'Saved activities', 'planned'],
  ['sharing_enabled', 'Trips with sharing enabled', 'shared'],
];

export function metricValue(key, value = 0) {
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: ['adoption_rate', 'activities_per_trip'].includes(key) ? 1 : 0 }) + (key === 'adoption_rate' ? '%' : '');
}

export function matchingReservations(rows, drilldown) {
  return rows.filter(row => {
    if (drilldown.rental && row.rental_id !== drilldown.rental) return false;
    if (drilldown.place && !row.items.some(item => item.place_key === drilldown.place)) return false;
    if (drilldown.source && !row.items.some(item => item.source === drilldown.source)) return false;
    if (drilldown.mode === 'planned' && !row.items.length) return false;
    if (drilldown.mode === 'shared' && (!row.items.length || !row.sharing_enabled)) return false;
    return true;
  });
}
